import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScaniaComponent } from './simple-icons-scania.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScaniaComponent ],
    exports:      [ SimpleIconsScaniaComponent ],
    bootstrap:    []
})
export class SimpleIconsScaniaModule {}
